import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ConditionalFormatDirective` represent a conditionalformat of the React Spreadsheet.
 * It must be contained in a `SheetDirective`.
 * ```tsx
 * <SpreadsheetComponent>
 *   <SheetsDirective>
 *    <SheetDirective>
 *    <ConditionalFormatsDirective>
 *    <ConditionalFormatDirective dataSource={data}></ConditionalFormatDirective>
 *    </ConditionalFormatsDirective>
 *    </SheetDirective>
 *   </SheetsDirective>
 * </SpreadsheetComponent>
 * ```
 */
export class ConditionalFormatDirective extends ComplexBase {
}
ConditionalFormatDirective.moduleName = 'conditionalFormat';
export class ConditionalFormatsDirective extends ComplexBase {
}
ConditionalFormatsDirective.propertyName = 'conditionalFormats';
ConditionalFormatsDirective.moduleName = 'conditionalFormats';
